import uuidv4 from 'uuid/v4';
export default uuidv4();


// WEBPACK FOOTER //
// ./src/utils/uuid.js